import { render, staticRenderFns } from "./save_money.vue?vue&type=template&id=6f563704&scoped=true&"
import script from "./save_money.vue?vue&type=script&lang=js&"
export * from "./save_money.vue?vue&type=script&lang=js&"
import style0 from "./save_money.vue?vue&type=style&index=0&id=6f563704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f563704",
  null
  
)

export default component.exports